<template lang="pug">
v-dialog(:value="value" @input="updateValue" max-width="468")
  v-card
    v-card-title.headline.justify-space-between
      | {{title}}
      image-upload-crop(
        v-slot="{fileDragOver}"
        @onImageCrop="model.thumbnail = $event"
        :ratio="[1,1]"
      )
        v-btn(
          fab
          depressed
          small
          :color="fileDragOver ? 'primary' : 'grey'"
        )
          img(
            v-if="model.thumbnail"
            :src="model.thumbnail"
          ).thumbnail
          v-icon(
            v-if="!model.thumbnail"
            color="white"
          ) mdi-image-multiple
    v-card-text
      v-form(ref="form")
        div.license-types
          div.license-types__label License type
          div.license-types__row
            v-checkbox.mr-4(
              v-model="model.is_auto"
              label="Auto"
              :error="formErrors.hasError('licenseTypes')"
              @change="formErrors.validField('licenseTypes')"
            )
            v-checkbox.mr-4(
              v-model="model.is_motor"
              label="Motor"
              :error="formErrors.hasError('licenseTypes')"
              @change="formErrors.validField('licenseTypes')"
            )
            v-checkbox(
              v-model="model.is_scooter"
              label="Scooter"
              :error="formErrors.hasError('licenseTypes')"
              @change="formErrors.validField('licenseTypes')"
            )
          div.license-types__error(v-if="formErrors.hasError('licenseTypes')")
            | {{ formErrors.fields.licenseTypes || 'Please select at least one license type' }}
        v-text-field(
          v-model="model.name" 
          label='Chapter name'
          :rules="[RULES.REQUIRED]"
          :error="formErrors.hasError('name')"
          :error-messages="formErrors.fields.name"
        )
        v-textarea(
          v-model="model.description" 
          label='Description (optional)'
          :error="formErrors.hasError('description')"
          rows="2"
          :error-messages="formErrors.fields.description"
        )
        v-text-field(
          v-model="model.order"
          type="number"
          label='Order (optional)'
          :error="formErrors.hasError('order')"
          :error-messages="formErrors.fields.order"
        )
        v-checkbox(
          v-model="model.publicVisible"
          label="Is chapter public visible"
        )
        v-checkbox(
          v-model="model.isDemo"
          label="Is demo chapter"
        )
        .tenant-checkboxes
          h4 Tenants
          v-checkbox(
            v-model="model.is_wiki"
            label="Wiki"
            :error="formErrors.hasError('is_wiki')"
            :error-messages="formErrors.fields.is_wiki"
          )
          v-checkbox(
            v-model="model.is_les"
            label="Les"
            :error="formErrors.hasError('is_les')"
            :error-messages="formErrors.fields.is_les"
          )
          v-checkbox(
            v-model="model.is_online"
            label="Online"
            :error="formErrors.hasError('is_online')"
            :error-messages="formErrors.fields.is_online"
          )
        div
          h4.mb-3 Thumbnail
            span.hint(v-if="!model.videoThumbnail") (Recommend to upload image with min width 900px)
          .image-wrapper.mb-3
            img(
              v-if="model.videoThumbnail"
              :src="model.videoThumbnail"
            ).thumbnail-video
          div.d-flex
            image-upload-crop(
              v-slot="{fileDragOver}"
              @onImageCrop="onImageCropHandler"
              :ratio="[16, 9]"
            )
              v-btn(outlined :color="fileDragOver ? 'primary' : ''")
                v-icon.mr-2(v-if="!fileDragOver") mdi-cloud-upload-outline
                v-icon.mr-2(v-else) mdi-cloud-upload
                span Upload image
            v-btn(outlined color="primary" v-if="model.videoThumbnail" @click="onRemoveCurrentImage").ml-4
              v-icon.mr-2 mdi-close
              span Remove image
        .d-flex.mt-10
          template(v-if="!editMode")
            v-btn(color="primary" outlined @click="closeModal").ml-auto.mr-3 Cancel
            v-btn(color="primary" depressed @click="addItem") Add
          template(v-if="editMode")
            v-btn(color="primary" outlined @click="closeModal").ml-auto.mr-3 Cancel
            v-btn(color="primary" depressed @click="updateItem") Save
</template>

<script>
import { REQUIRED } from "@/util/validation-rules";
import FormErrors from "@/util/form-errors"
import ErrorMixin from "@/mixins/errors.mixin"
import ChapterCategoryModel from "@/app/exercise/modules/training-chapter-categories/core/models/ChapterCategoryModel"
import ChapterCategorySvc from "@/app/exercise/modules/training-chapter-categories/core/chapter-category-service"
export default {
  components: {
    imageUploadCrop: () => import('@/app/exercise/components/ImageUploadCrop.vue'),
  },
  props: {
    editMode: {
      default: false,
      type: Boolean,
    },
    itemModel: {
      default: null,
      type: Object,
    },
    value: Boolean,
  },

  mixins: [ErrorMixin],

  computed: {
    title() {
      if (this.editMode) {
        return 'Edit Chapter'
      }
      return 'Add Chapter'
    },
  },

  data: () => ({
    svc: null,
    formErrors: null,
    model: new ChapterCategoryModel(),
    RULES: {
      REQUIRED,
    },
  }),

  created() {
    this.init()
  },

  watch: {
    value(isModalOpen) {
      if(isModalOpen) {
        this.setModelFromProp();
      } else {
        this.formReset();
      }
    },
  },

  methods: {
    init() {
      this.svc = new ChapterCategorySvc()
      this.formErrors = new FormErrors()
    },
    formReset() {
      this.model = new ChapterCategoryModel();
      this.formErrors = new FormErrors();
      this.$refs.form.reset();
    },
    setCroppedImage({file}) {
      this.model.image = file;
    },
    setModelFromProp() {
      Object.assign(this.model, this.itemModel );
    },
    updateValue(value) {
      this.$emit('input', value)
    },
    closeModal() {
      this.updateValue(false);
    },
    async addItem() {
      try {
        if (!this.$refs.form.validate() || !this.model.validate(this.formErrors) ) {
          this.$notify({text: 'Invalid fields', type: 'error' })
          return false;
        }
        let res = await this.svc.create(this.model)
        this.$emit('itemCreated');
        this.closeModal();
      } catch (error) {
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors, 
          apiAttributes: this.model._apiAttributes
        });
      }
    },
    async updateItem() {
      const isModelChanged = JSON.stringify(this.model) !== JSON.stringify(this.itemModel);
      if (!isModelChanged) {
        this.closeModal();
        return;
      }
      try {
        if (!this.$refs.form.validate() || !this.model.validate(this.formErrors) ) {
          this.$notify({text: 'Invalid fields', type: 'error' })
          return false;
        }
        let res = await this.svc.put(this.model.id, this.model)
        this.$emit('itemUpdated');
        this.closeModal();
      } catch (error) {
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors, 
          apiAttributes: this.model._apiAttributes
        });
      }
    },
    onImageCropHandler(ev) {
      this.model.videoThumbnail = ev;
    },
    onRemoveCurrentImage() {
      this.model.videoThumbnail = null;
    },
  },
}
</script>
<style lang="scss" scoped>
.v-btn::v-deep {
  .v-btn__content {
    max-width: 100%;
  }
}
.thumbnail {
  max-width: 100%;
  border-radius: 50%;
}

.thumbnail-video {
  display: block;
  max-width: 100%;
  height: auto;
  padding: 4px;
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.license-types {
  &__label {
    color: $label-color;
    font-weight: 400;
    font-size: 12px;
    margin-bottom: 2px;
  }

  &__row {
    display: flex;
    align-items: center;

    &::v-deep {
      label {
        font-weight: 400;
        margin-bottom: 0;
      }

      .v-input {
        margin-top: 0;
      }

      .v-messages {
        display: none;
      }
    }
  }

  &__error {
    color: $error-color;
    font-size: 12px;
    margin-bottom: 24px;
    margin-top: -4px;
  }
}
</style>
